// Canonical source codes for affiliate link-gen requests (ClickLog attribution).
// Matches backend canonical set — lowercase, dash-free, ≤16 chars.
export const LinkSource = {
    ProductDetail: 'pd',
    SearchResult: 'sr',
    Home: 'hm',
    Trending: 'tr',
    Saved: 'sv',
    RecentlyViewed: 'rv',
    PriceWatch: 'pw',
    Voucher: 'vc',
    Converter: 'lc',
    GhostOrder: 'go',
    Redirect: 'rd',
    Category: 'ec',
    ShopeeXu: 'sx',
    ShopeeVideo: 'vd',
    Extension: 'ex',
    // Mua từ danh sách shop/SP của đợt thưởng (block "áp dụng cho" + trang /di-den)
    Reward: 'rw',
    // Trang deal 1K/9K/29K (/flash-sale) — thay trang ngoài sansale.longhousee.net
    FlashSale: 'fs',
};
